import Bradley from './meetTheTeamImages/Bradley.png'
import Callum from './meetTheTeamImages/Callum.png'
import Caroline from './meetTheTeamImages/Caroline.png'
import Deanne from './meetTheTeamImages/Deanne.png'
import Gary from './meetTheTeamImages/Gary.png'
import Gerard from './meetTheTeamImages/Gerard.png'
import Grace from './meetTheTeamImages/Grace.png'
import Jake from './meetTheTeamImages/Jake.png'
//import James from './meetTheTeamImages/James.png'
import JimA from './meetTheTeamImages/Jim A.png'
import KEV from './meetTheTeamImages/KEV.png'
// import Kirean from './meetTheTeamImages/Kieran.png'
import Lee from './meetTheTeamImages/Lee.png'
import Lindsay from './meetTheTeamImages/Lindsay.png'
//import Lynsey from './meetTheTeamImages/Lynsey.png'
import Mark from './meetTheTeamImages/Mark.png'
import Martin from './meetTheTeamImages/Martin.png'
import Neil from './meetTheTeamImages/Neil.png'
import Nicola from './meetTheTeamImages/Nicola.png'
import Rashida from './meetTheTeamImages/Rashida.png'
//import Ronnie from './meetTheTeamImages/Ronnie.png'
//import Steve from './meetTheTeamImages/Steve.png'
import TeriAnn from './meetTheTeamImages/Teri-Ann.png'
import Eddie from './meetTheTeamImages/eddie.png'
import Greg from './meetTheTeamImages/Greg.png'
import Sean from './meetTheTeamImages/Sean.png'
import Sheena from './meetTheTeamImages/Sheena.png'
import Ivan from './meetTheTeamImages/Ivan.png'
import PhilG from './meetTheTeamImages/philg.png'
import DavidS from './meetTheTeamImages/davids.png'


const MeetTheTeamData = [
    {
        img: Mark,
        name: 'MARK LANGLEY (AKA TWINKLE TOES)',
        role: '-',
        body: [
            'Legend, creator, pioneer & influencer.',
            'D in GCSE Spanish. Yellow belt in Karate. Ex ballerina',
        ]
    },
    {
        img: JimA,
        name: 'JIM ASHLEY',
        role: '-',
        body: [
            'Jim enjoys nothing more than the great outdoors. He has a slight obsession with challenging himself to new adventures, and has his sights set on getting to Everest Base camp (one day) along with summitting Kilimanjaro!  When not outward-bound, he has a passion for food (loves a bit of lobster and steak or curry, if you’re asking) and, of course, his family time.'  ]
    },
    {
        img: Lee,
        name: 'LEE RHODES',
        role: '-',
        body: [
            'Married with one daughter, Lee is a sports fanatic who loves most sports, but he is particularly partial to a round of golf. Another of RDA’s natural adventurers, he likes to travel, meet people and take on new experiences.'  ]
    },
    {
        img: Martin,
        name: 'MARTIN JOHNSON',
        role: '-',
        body: [
            'If not watching sport (Essex cricket or West Ham United) Martin will be found watching comedy sitcoms, panel shows and stand up. If you asked his three grown-up kids what he is best known for, they will all say ‘dad jokes’. When Dad rolls out his jokes, they will be found rolling their eyes rather than rolling on the floor laughing.'  ]
    },

    {
        img: Nicola,
        name: 'NICOLA FAULKNER',
        role: '-',
        body: [
            'Nicola likes to pass her downtime taking countryside walks with her small, pampered pooch. She’s a social animal herself, and loves spending time with friends, whether at home, in a restaurant or, preferably, dancing in some muddy field at the odd summer festival (or two.) (Or three.)'  ]
    },
    {
        img: Bradley,
        name: 'BRADLEY FIELDHOUSE',
        role: '-',
        body: [
            'Bradley is another of RDA’s sports nuts, with a particular passion for football, NFL and boxing. If there’s no sport to watch he will spend his time taking his chocolate Labrador for walks or cleaning and detailing his beloved car. (Wax on, wax off, Brad.)'  ]
    },
    {
        img: Deanne,
        name: 'DEANNE NEL',
        role: '-',
        body: [
            'Proud South African Deanne is mother to a beautiful daughter and enjoys being active – running and hockey are top of her list. She’ll get to tick off a bucket-list item if her inclusion in the ballot for the London Marathon leads to a place on the starting line. She loves socialising with friends, especially over a “braai” (a barbecue to you and me), where she’ll be sipping a good red wine or a tasty gin.'  ]
    },
    {
        img: KEV,
        name: 'KEVIN AUCHOYBUR',
        role: '-',
        body: [
            'Kevin is a font of knowledge on all things tech, from cars to quantum computing and everything in between. Whether it’s nuclear fusion or new gearboxes for formula one, Kev’s your man. He likes to relax with an audiobook or watching sport on the TV, with a nice little nip of whisky or whiskey in hand.'  ]
    },
    {
        img: Callum,
        name: 'CALLUM BRUNNING',
        role: '-',
        body: [
            'Callum is a keen cricketer who can often be found searching in the rough for his missing golf ball. He is learning to play the guitar has also developed a new-found passion for baking. And as yet another RDA member with a head for heights, one of his lifetime ambitions is to climb Mount Everest.'  ]
    },
    // NEw added
    {
        img: Sean,
        name: 'SEAN RAMNARINE',
        role: '-',
          body: [
            'Usually found reading an essay to nowhere, where the rivers taste like wine, and you ask the dust for directions home.'  ]
     },
    {
        img: Sheena,
        name: 'SHEENA ',
        role: '-',
        body: [
            'In between guzzling all the teas the world has to offer, Sheena also likes to cross-stitch and hopes to master roller-skates this summer. Watch this space...'  ]

          },
    {
        img: Ivan,
        name: 'IVAN ',
        role: '-',
        body: [
            'Ivan is married with two daughters and one grandson, alongside whom he enjoys fine dining and socialising with friends. When alone he likes to listen to music and read a suspense novel or crime thriller; a penchant for the dark side that perhaps also explains why he has for many years been a regular match-goer at Stamford Bridge.'  ]
    },
    {
        img: Eddie,
        name: 'EDDIE REYNOLDS',
        role: '-',
        body: [
            'Eddie can usually be found at a racetrack looking after the next batch of budding Lewis Hamiltons. Otherwise he’ll be at ballet or horse riding lessons - for his two daughters. A keen golfer who spends most of the time in the rough, he’s a runner and a dab hand with a shot gun; shooting clays, not pigeons.'  ]
    },
    {
        img: PhilG,
        name: 'PHIL GLEW',
        role: '-',
        body: [
            'Phil Glew, once a race driver, now driver manager, spends most of his time at racetracks. His real loves are DIY, skiing, going to the horse races and his new-found sporting passion – golf.'  ]
    },
    {
        img: DavidS,
        name: 'DAVID STOCKER',
        role: '-',
        body: [
            'David Stocker is a Chartered Certified Accountant and petrolhead, married with two grown up children. When not poring over finances, he can be found at a race circuit, especially Le Mans each year. He also enjoys live music whenever possible.'  ]
    },


  ]


export function GetSortedMeetTheTeam (){
    function compare( a, b ) {
        const aLastName = a.name.split(" ")[1]
        const bLastName = b.name.split(" ")[1]

        if ( aLastName < bLastName ){
          return -1;
        }
        if ( aLastName > bLastName ){
          return 1;
        }
        return 0;
      }

      console.log(MeetTheTeamData.sort(compare))

    return(MeetTheTeamData)
}
